import { render, staticRenderFns } from "./BlogQuestion.vue?vue&type=template&id=797b165a&scoped=true"
import script from "./BlogQuestion.vue?vue&type=script&lang=js"
export * from "./BlogQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b165a",
  null
  
)

export default component.exports